import { useAppDispatch } from '../../../configuration/setup/hooks.ts';
import { togglePersonalCheckbox, useNewsletterApproved } from '../../personal/personalInfoSlice.ts';
import { Checkbox } from '../../../components/Checkbox.tsx';
import type { PropsWithChildren } from 'react';

export const NewsletterApprovedCheckbox = (
    props: PropsWithChildren<{
        disabled?: boolean;
        className?: string;
        error?: string;
    }>
) => {
    const value = useNewsletterApproved();
    const messageId = 'registration.personalData.newsletterApproved';

    const dispatch = useAppDispatch();
    const onChange = () => dispatch(togglePersonalCheckbox('newsletterApproved'));

    return (
        <Checkbox
            value={value}
            onChange={onChange}
            disabled={props.disabled}
            className={props.className}
            messageId={messageId}
            error={props.error}
        >
            {props.children}
        </Checkbox>
    );
};
